import { SearchFilterModal, type FilterableField, type FilterCondition as UIFilterCondition } from '@/components/ui'
import type { RegistrationField, FilterCondition } from '../types'

interface AttendeeFilterModalProps {
  open: boolean
  onClose: () => void
  registrationFields: RegistrationField[]
  filterNameSearch: string
  filterConditions: FilterCondition[]
  onFilterNameSearchChange: (value: string) => void
  onFilterConditionsChange: (conditions: FilterCondition[]) => void
  onApplyFilters: () => void
  onResetFilters: () => void
}

/**
 * Convert RegistrationField to FilterableField for the generic SearchFilterModal
 */
function toFilterableFields(registrationFields: RegistrationField[]): FilterableField[] {
  // Only include fields that make sense to filter
  const filterableKinds = ['single_choice', 'dropdown', 'multiple_choice', 'text', 'short_text']

  return registrationFields
    .filter(field => filterableKinds.includes(field.kind))
    .map(field => ({
      id: field.id,
      identifier: field.identifier,
      label: field.label,
      type: (field.kind === 'single_choice' || field.kind === 'dropdown')
        ? 'select' as const
        : field.kind === 'multiple_choice'
          ? 'multiselect' as const
          : 'text' as const,
      options: field.options?.map(opt => ({
        label: opt.label,
        value: opt.value,
      })),
    }))
}

export default function AttendeeFilterModal({
  open,
  onClose,
  registrationFields,
  filterNameSearch,
  filterConditions,
  onFilterNameSearchChange,
  onFilterConditionsChange,
  onApplyFilters,
  onResetFilters,
}: AttendeeFilterModalProps) {
  const filterableFields = toFilterableFields(registrationFields)

  return (
    <SearchFilterModal
      open={open}
      onClose={onClose}
      title="Filter"
      description="Show attendees that match the following..."
      fields={filterableFields}
      filterConditions={filterConditions as UIFilterCondition[]}
      onFilterConditionsChange={onFilterConditionsChange as (conditions: UIFilterCondition[]) => void}
      showNameSearch={true}
      nameSearchPlaceholder="Search name & keywords"
      nameSearchValue={filterNameSearch}
      onNameSearchChange={onFilterNameSearchChange}
      onApply={onApplyFilters}
      onReset={onResetFilters}
    />
  )
}
